import { setupConfig } from '@ionic/react';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from './App';
import DBStorage from './library/DBStorage';
import { store } from './redux/store';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import './index.css';

// import reportWebVitals from './reportWebVitals';
setupConfig({
  mode: "md"
});

window.storage = new DBStorage()

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
